(function(app) {

    app.factory("unauthorizedInterceptor",
        [
            "$location", "$q", "$injector", function($location, $q, $injector) {
                return {
                    request: function(config) {
                        return config || $q.when(config);
                    },
                    requestError: function(request) {
                        return $q.reject(request);
                    },
                    response: function(response) {
                        return response || $q.when(response);
                    },
                    responseError: function(response) {
                        if (response && response.status === 401) {
                            $injector.get("$state").transitionTo("Home.401");
                        }

                        return $q.reject(response);
                    }
                };
            }
        ]);

    app.config([
        "$stateProvider", "$urlRouterProvider", "$httpProvider", function($stateProvider, $urlRouterProvider, $httpProvider) {
            $stateProvider.state("Home.401",
                {
                    component: "unauthorized",
                    data: {
                        pageTitle: "401 Access Denied"
                    }
                });

            $urlRouterProvider.otherwise(function($injector, $location) {
                var state = $injector.get("$state");
                state.go("Home.401");
                return $location.path();
            });

            $httpProvider.interceptors.push("unauthorizedInterceptor");
        }
    ]);

    app.component("unauthorized",
        {
            templateUrl: "/App/401/401-template.html"
        });

})(window.app); //jshint ignore:line